import { useCallback } from 'react';
import type {
  PersonalMeetingData,
  UseMeetingDetailsHandlersParams,
  UseMeetingDetailsHandlersReturn,
} from '../types';

const useMeetingDetailsHandlers = ({
  updateMeetingData,
  toggleDefaultMeeting,
}: UseMeetingDetailsHandlersParams): UseMeetingDetailsHandlersReturn => {
  const handleMeetingTitleSave = useCallback(
    (value: string) => {
      updateMeetingData(
        (prev: PersonalMeetingData) => ({
          ...prev,
          meetingTitle: value,
        }),
        { field: 'meetingTitle', successMessage: 'Personal Meeting Title updated' },
      );
    },
    [updateMeetingData],
  );

  const handleMeetingIdSave = useCallback(
    (value: string) => {
      updateMeetingData(
        (prev: PersonalMeetingData) => ({
          ...prev,
          meetingId: value,
        }),
        { field: 'meetingId', successMessage: 'Personal Meeting ID updated' },
      );
    },
    [updateMeetingData],
  );

  const handlePasscodeSave = useCallback(
    (value: string) => {
      updateMeetingData(
        (prev: PersonalMeetingData) => ({
          ...prev,
          passcode: value,
        }),
        { field: 'passcode', successMessage: 'Passcode updated' },
      );
    },
    [updateMeetingData],
  );

  const handleDefaultToggle = useCallback(
    (checked: boolean) => {
      void toggleDefaultMeeting(checked);
    },
    [toggleDefaultMeeting],
  );

  return {
    handleMeetingTitleSave,
    handleMeetingIdSave,
    handlePasscodeSave,
    handleDefaultToggle,
  };
};

export default useMeetingDetailsHandlers;
